import styled from "styled-components";

// import { getBgGradient } from '../../utils';
/* ${props => getBgGradient(props.theme.color.yellow, props.theme.color.red)}; */

const PContainer = styled.div`
  width: 100%;
  /* height:100%; */
  /* border: 2px solid lightblue; */

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  /* position: relative; */
  overflow: hidden;



`;

export default PContainer;
